import React, { useEffect, useState, useRef } from 'react';
import AdsApi from '../api/AdsApi';
import ProductsApi from '../api/ProductsApi';
import Handlebars, { compileHandlebarsTemplate } from '../utils/Handlebars';
import ClientAnalytics from '../analytics/ClientAnalytics';

const PublisherProductGrid = ({publisherProductSource, publisherId, publisherName}) => {
  if (!publisherProductSource) return;

  const [compiledTemplate, setCompiledTemplate] = useState(null);
  const [productSource, setProductSource] = useState(null);
  const isLoadTracked = useRef(false);
  const root = useRef(null);

  useEffect(() => {
    // code to run on component mount
    const {productPageTemplate: templateId, productDataSource: sourceId} = publisherProductSource;
    if (!templateId || !sourceId) return;

    const fetchData = async () => {
      const [template, productSource] = await Promise.all([
        AdsApi.getTemplate(templateId),
        ProductsApi.getProductDataSource(sourceId),
      ]);
      setProductSource(productSource);
      if (template && template.templateContent) {
        setCompiledTemplate(() => compileHandlebarsTemplate(Handlebars, template.templateContent));
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // setup tracking
    if (!compiledTemplate || !productSource) {
      return;
    }

    if (!isLoadTracked.current) {
      const {productPageTemplate: templateId, productDataSource: sourceId} = publisherProductSource;
      const {title: sourceName} = productSource;
      ClientAnalytics.sendProductPageLoad(publisherId, templateId, sourceId, publisherName, sourceName);
      isLoadTracked.current = true;
      setupSingleProductTracking();
    }
  }, [compiledTemplate, productSource]);

  /**
   * Assumes certain fixed data attributes used in the tamplate to tag product elements
   */
  const setupSingleProductTracking = () => {
    const rootElem = root.current;
    if (!rootElem) return;

    const productElems = rootElem.querySelectorAll('[data-vp-product]');
    for (const productElem of productElems) {
      const productId = productElem.dataset.vpProduct;
      productElem.addEventListener('click', () => trackProductClick(Number(productId)));
    }
  };

  const trackProductClick = (productId) => {
    const {productPageTemplate: templateId, productDataSource: sourceId} = publisherProductSource;
    const {title: sourceName} = productSource;
    ClientAnalytics.sendProductPageProductClick(publisherId, templateId, sourceId, productId, publisherName, sourceName);
  };

  if (!compiledTemplate || !productSource) {
    return null;
  }
  return (
    <div
      ref={root}
      className="vup-product-grid"
      dangerouslySetInnerHTML={{__html: compiledTemplate(productSource)}}
     />
  );
};

export default PublisherProductGrid;